import { styled } from "@mui/material/styles";
import { ColDataProps } from "../../LandingPage";
import { Button } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Popconfirm } from "antd";

export interface IndicationsCardProps {
  metadata: ColDataProps[];
  indications: (ColDataProps & { therapeuticArea: string })[];
  handleDelete: (indication: string, ta: string) => void;
  isInformaticist: boolean | null | undefined;
}

const IndicationsCard: React.FC<IndicationsCardProps> = ({
  metadata,
  indications,
  handleDelete,
  isInformaticist,
}) => {
  return (
    <div>
      <TitleRow>
        <span className="module-title">
          <i className="title-text">Indications List</i>
        </span>
      </TitleRow>
      <NumbersContainer>
        {metadata.map((d: ColDataProps) => (
          <div className="count" key={d.key}>
            <p style={{ marginBlockEnd: "0" }}>{d.value}</p>
            <span style={{ color: "#82786F" }}>{d.label}</span>
          </div>
        ))}
      </NumbersContainer>
      {indications
        .filter((indication) => indication && indication.key)
        .map((indication) => (
          <Board key={indication.key}>
            <Status>{indication.key}</Status>
            <NumbersContainer>
              <div className="count" key={indication.key}>
                <p>{indication.value}</p>
                <span>{indication.label}</span>
              </div>
              {isInformaticist && (
                <div className="count">
                  <Popconfirm
                    title="Are you sure you want to delete this indication?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => {
                      handleDelete(indication.key, indication.therapeuticArea);
                    }}
                  >
                    <DeleteButton variant="outlined">
                      <DeleteForeverIcon style={{ marginRight: "0.5rem" }} />
                      Delete
                    </DeleteButton>
                  </Popconfirm>
                </div>
              )}
            </NumbersContainer>
          </Board>
        ))}
    </div>
  );
};

const Status = styled("div")({
  flex: "1",
  textAlign: "center",
  alignContent: "center",
  background: "#F5F5F5",
  "& p": {
    fontSize: "1.125rem",
  },
});

const DeleteButton = styled(Button)({
  textTransform: "none",
  fontWeight: 500,
  backgroundColor: "#F9F9F9",
  borderRadius: "1.563rem",
  alignSelf: "end",
  marginRight: "2rem",
  border: "1px solid #D52B1E !important",
  height: "37px",
  marginTop: "28px",
  cursor: "pointer",
});

const NumbersContainer = styled("div")({
  display: "flex",
  flex: "3",
  marginBottom: "1rem",
  "& .count": {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&:last-child": {
      borderRight: "1px solid transparent",
    },
    "& p": {
      fontSize: "2.375rem",
      height: "3.125rem",
    },
    "& span": {
      color: "color: rgba(0, 0, 0, 0.6)",
      textAlign: "center",
      fontSize: "0.625rem",
      fontWeight: "bold",
    },
  },
});

const TitleRow = styled("div")({
  paddingBottom: "0.625rem",
  marginBottom: "1rem",
  borderBottom: "1px solid #D5D2CA",
  "& .module-title": {
    fontSize: "1.25rem",
  },
  "& .title-text": {
    fontStyle: "normal",
  },
});

const Board = styled("div")({
  marginBottom: "1rem",
  display: "flex",
  background: "#FAFAFA rgba(255, 255, 255, 0.05)",
  boxShadow:
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)",
  "& p": {
    marginBottom: "0.2rem",
  },
  "& span": {
    color: "#82786F",
  },
});

export default IndicationsCard;
